const LOGIN_PATHS = new Set(["/", "/login"]);

export const canInitializePermissions = documentRoot =>
    typeof documentRoot?.querySelector === "function" &&
    documentRoot.querySelector('meta[name="api-token"]') !== null;

export const shouldRedirectToLogin = pathname => !LOGIN_PATHS.has(pathname);

export const shouldRedirectExpiredSession = (status, pathname) =>
    (status === 401 || status === 419) && shouldRedirectToLogin(pathname);
